export const WHITE = '#fff';
export const GREEN = '#00bda5';
export const GREY = '#cbd6e2';

export const DEFAULT_PRIMARY_COLOR = '#f15f79';
export const DEFAULT_TEXT_COLOR = '#33475b';
export const DEFAULT_ERROR_TEXT_COLOR = '#f2545b';
export const DISABLED_BACKGROUND_COLOR = '#eaf0f6';
export const DISABLED_TEXT_COLOR = '#b0c1d4';

export const DEFAULT_HELP_TEXT_COLOR = '#425b76';
export const DEFAULT_PLACEHOLDER_TEXT_COLOR = '#7b98b6';

export const DEFAULT_INPUT_BORDER_COLOR = '#cbd6e2';
export const DEFAULT_INPUT_BACKGROUND_COLOR = '#f5f8fa';

export const DEFAULT_HAPPY_COLOR = '#a2d28f';
export const DEFAULT_NEUTRAL_COLOR = '#fea58e';
export const DEFAULT_SAD_COLOR = '#ea90b1';

export const DEFAULT_TOOLTIP_BACKGROUND_COLOR = '#425b76';
export const DEFAULT_TOOLTIP_TEXT_COLOR = WHITE;
